/**
 * @brief 전역적으로 규칙을 추가한다.
 */
import {extend} from 'vee-validate'
import { required, email, confirmed} from 'vee-validate/dist/rules'; // 기본으로 제공되는 규칙을 모아둔 파일

//*****************************************************************//
// 고정적인 규칙
//*****************************************************************//
// 필수값 검사
extend('required', {
    ...required,
    // message: (fieldName) => {
    //     return `${fieldName}은(는) 필수 입력항목 입니다.`
    // }
    message: '필수 정보입니다.'
})

// 전화번호 검사 (Only Mobile)
extend('mobileTel', {
    validate(value){
        return /^\d{2,4}-?\d{2,4}-?\d{2,4}$/gm.test(value)
    },
    message: (fieldName) => {
        return `${fieldName} 형식이 아닙니다.`
    }
})

// 전화번호 검사
extend('tel', {
    validate(value){
        return /^\d{2,3}\d{3,4}\d{4}$/.test(value)
    },
    message: (fieldName) => {
        return `${fieldName} 형식이 아닙니다.`
    }
})

// 주민등록번호 검사 (RRN: Resident Registration Number)
// 예: xxxxxx-xxxxxxx
extend('rrn', {
    validate(value){
        return /^(?:[0-9]{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[1,2][0-9]|3[0,1]))-[1-4][0-9]{6}$/.test(value)
    },
    message: (fieldName) => {
        return `${fieldName} 형식이 아닙니다.`
    }
})

// 날짜 검사
// 예: YYYY-MM-DD
extend('date', {
    validate(value){
        return /^(19[0-9][0-9]|20\d{2})-(0[0-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/.test(value)
    },
    message: (fieldName) => {
        return `${fieldName} 형식이 아닙니다.`
    }
})

// 날짜 검사
// 예: YYYYMMDD
extend('dateNoHyphen', {
    validate(value){
        return /^(19[0-9][0-9]|20\d{2})(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/.test(value)
    },
    message: (fieldName) => {
        return `${fieldName} 형식이 아닙니다.`
    }
})

// 예: YYYY
// 18xx - 20xx
extend('year', {
	validate(value){
			return /^(18[0-9][0-9]|19[0-9][0-9]|20\d{2})$/.test(value)
	},
	message: (fieldName) => {
			return `${fieldName} 형식이 아닙니다.`
	}
})

// 이메일 검사
extend('email', {
    ...email,
    message: (fieldName) => {
        return `${fieldName} 형식이 아닙니다.`
    }
})

// 재확인 검사
extend('confirmed', {
    ...confirmed,
    params: ['target'],
    message: (fieldName, placeholders) => {
        return `${placeholders.target}와 일치하지 않습니다.`
    }
});


//*****************************************************************//
// 조건에 따른 규칙
//*****************************************************************//
// 아이디 검사
const ID_MIN = 5
const ID_MAX = 20
const ID_REGEX = new RegExp("^[a-z0-9-_]{"+ ID_MIN + "," + ID_MAX + "}$")
extend('id', {
    validate(value){
        return ID_REGEX.test(value);
    },
    message: (fieldName) => {
        return `${fieldName}는 ${ID_MIN}~${ID_MAX}자의 영문 소문자, 숫자와 특수기호(_),(-)만 사용 가능합니다.`
    }
    // 속성값을 받아서 사용하는 방식, 예제로 남겨둠.
    // validate(value, args){
    //     var length = value.length
    //     return (length >= args.min && length <= args.max) && /^[a-z0-9-_]+$/.test(value);
    // },
    // params: ['min', 'max'],
    // message: (fieldName, placeholders) => {
    //     return `${fieldName}는 ${placeholders.min}~${placeholders.max}자의 영문 소문자, 숫자와 특수기호(_),(-)만 사용 가능합니다.`
    // }
})

// 비밀번호 검사
const PW_MIN = 8
const PW_MAX = 16
const PW_REGEX = new RegExp("^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{" + PW_MIN + "," + PW_MAX + "}$")
extend('pw', {
    validate(value){
        return PW_REGEX.test(value);
    },
    message: (fieldName) => {
        return `${fieldName}는 ${PW_MIN}~${PW_MAX}자 영문 대 소문자, 숫자, 특수문자 조합을 사용하세요.`
    }
})

// 이름 검사
const NAME_MIN = 2
const NAME_MAX = 16
const NAME_REGEX = new RegExp("^[가-힣a-zA-Z]{"+ NAME_MIN + "," + NAME_MAX +"}$")
extend('name', {
    validate(value){
        return NAME_REGEX.test(value)
    },
    message: (fieldName) => {
        return `${fieldName}은 한글과 영문 대 소문자를 사용하세요. (특수기호, 공백 사용 불가, ${NAME_MIN}~${NAME_MAX}자)`
    }
})

// 인증번호 검사
const LENGTH = 6
const VERIFY_REGEX = new RegExp("^(\\d){" + LENGTH + "}$")
extend('verifyNum', {
    validate(value){
        return VERIFY_REGEX.test(value)
    },
    message: (fieldName) => {
        return `${fieldName} ${LENGTH}자리를 다시 확인해주세요.`
    }
})

// 기업 이름 검사
const CORP_NAME_MIN = 1
const CORP_NAME_MAX = 42
const CORP_NAME_REGEX = new RegExp("^[가-힣a-zA-Z ]{"+ CORP_NAME_MIN + "," + CORP_NAME_MAX +"}$")
extend('corpName', {
    validate(value){
        return CORP_NAME_REGEX.test(value)
    },
    message: (fieldName) => {
        return `${fieldName}은 한글과 영문 대 소문자를 사용하세요. (특수기호 사용 불가, ${CORP_NAME_MIN}~${CORP_NAME_MAX}자)`
    }
})
